import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeatureGuard } from '../../extras/feature.guard';
import { FeesListComponent } from './pages/fees-list/fees-list.component';

// const routes: Routes = [];
const feesroutes: Routes = [
    { path: 'office-fees', component: FeesListComponent, canActivate: [FeatureGuard], data: { feature: 'config.op_settings.fees' } },
    // The add / edit dialog on the list (these URLs open it).
    { path: 'office-fees/add', component: FeesListComponent, canActivate: [FeatureGuard], data: { feature: 'config.op_settings.fees' } },
    { path: 'office-fees/edit/:feeId', component: FeesListComponent, canActivate: [FeatureGuard], data: { feature: 'config.op_settings.fees' } }
];
@NgModule({
    imports: [RouterModule.forChild(feesroutes)],
    exports: [RouterModule]
})
export class FeesRoutingModule { }
